import { createReducer, on } from "@ngrx/store";
import * as EmployeeActions from "../employees/employee-actions";
import { CurrentEmployeeStateInterface } from "src/app/company/models/currentEmployeeStateInterface";

export const initialState: CurrentEmployeeStateInterface = {
    isLoading: false,
    currentEmployee: [],
    error: null,
};

export const currentEmployeeReducers = createReducer(
    initialState, 

    // get Current Employee
    on(EmployeeActions.getCurrentEmployee, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(EmployeeActions.getCurrentEmployeeSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        currentEmployee: action.employee
    })),
    on(EmployeeActions.getCurrentEmployeeFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),
);